<template>
  <section>
    <fixed-header title="Expenses List" :records="pageInfo.totalItems">
      <template v-slot:center>
        <add-expense v-if="checkClaim(CAN_POST_PAYMENT)" @onChange="updateList"></add-expense>
      </template>
    </fixed-header>
    <div class="animated fadeIn Expenses--Expenses-list">
      <b-row>
        <b-col>
          <div style="margin-top: 41px;" class="card">
            <div class="card-body">
              <div class="d-flex justify-content-start align-items-end mb-2">
                <!-- <b-form-group label="Source Id" class="mr-2">
                  <b-form-select
                    v-model="filters.sourceId"
                    :plain="true"
                    @change="onSearch"
                  >
                    <option
                      v-for="source in sortSelect(sourceIds)"
                      :key="source.id"
                      :value="source.id"
                    >{{source.name}}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Account Id" class="mr-2">
                  <b-form-select
                    v-model="filters.accountId"
                    :plain="true"
                    @change="onSearch"
                  >
                    <option
                      v-for="source in sortSelect(chartOfAccounts,'accountName')"
                      :key="source.id"
                      :value="source.id"
                    >{{source.accountName}}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Reference Id " class="mr-2">
                  <b-form-input v-model="filters.ReferenceId" size="sm" type="text" @input="onSearch"></b-form-input>
                </b-form-group> -->
                <date-range-picker :dateFrom="filters.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
                <div class="clear-filter-button-container">
                  <b-button size="sm" @click="clearFilter">Clear filters</b-button>
                </div>
              </div>
              <grid-component
                isResizable
                isReorderable
                isSortable
                :canEdit="checkClaim(CAN_POST_PAYMENT)"
                :canDelete="checkClaim(CAN_POST_PAYMENT)"
                :gridId="gridId"
                :pageable="pageable"
                :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
                :take="pageInfo.pageSize"
                :itemData="itemData"
                :pageSizes="pageInfo.pageSize"
                :totalItems="pageInfo.totalItems"
                :fields="fields"
                :sortBy="pageInfo.sortBy"
                :sortOrder="pageInfo.sortOrder"
                :sortMethod="sortGrid"
                :onDelete="onDelete"
                :onEdit="onEdit"
                :handleRowClick="handleRowClick"
                @getData="onGetData"
                :isTblLoader="tblLoader"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
    import { mapActions, mapGetters, mapMutations} from 'vuex';
    import { GRID_PAGE_SIZES, GRID_ID, SEARCH_DEBOUNCE_TIME, EXPENSE_SOURCE_IDS } from '@/shared/constants';
    import GridSettings from '@/shared/components/GridSettings';
    import GridComponent from '@/shared/components/GridComponent';
    import gridFields from './fields';
    import debounce from 'lodash/debounce';
    import FixedHeader from '@/shared/components/FixedHeader/index';
    import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
    import AddExpense from './components/edit';

    export default {
        components: {
            GridSettings,
            GridComponent,
            FixedHeader,
            DateRangePicker,
            AddExpense,
        },
        metaInfo: () => ({
            title: 'Expenses',
        }),
        data() {
            return {
                fields: gridFields,
                gridId: GRID_ID.EXPENSES,
                pageable: {
                    pageSizes: GRID_PAGE_SIZES,
                },
                selectedRowItemId: 0,
                sourceIds: EXPENSE_SOURCE_IDS,
                chartOfAccounts: [],
            };
        },
        computed: {
            ...mapGetters('expenses', [
                'gridList',
                'pageInfo',
                'filters',
                'lastOpenedId',
                'tblLoader'
            ]),
            ...mapGetters('account', ['gridSettingsById']),
            itemData() {
                if (this.gridList == undefined || this.gridList.length === 0) return [];
                return this.gridList.map((Expense) => ({...Expense, selected: Expense.id === this.selectedRowItemId}));
            },
        },
        methods: {
            ...mapMutations('expenses', ['setItem']),
            ...mapActions('expenses', ['getAll', 'sortGrid', 'getPage', 'search', 'deleteRecord', 'clearFilters', 'getChartOfAccounts']),
            ...mapActions('account', ['saveGridSettings']),
            gridSettings() {
                return this.gridSettingsById(this.gridId);
            },
            onSearch: debounce(function (data = false) {
                if (typeof data === 'object') {
                    Object.assign(this.filters, data)
                }
                this.search(this.filters);
            }, SEARCH_DEBOUNCE_TIME),

            clearFilter(callSearch = true) {
                this.clearObject(this.filters);
                if (callSearch) {
                    this.search(this.filters);
                }
            },
            onEdit(props) {
                this.setItem({resource: 'expense', payload: props});
                this.$bvModal.show('expense-modal');
            },
            handleRowClick(row) {
                //this.setItem({ resource: 'lastOpenedId', payload: row.dataItem.id });
                //this.selectedRowItemId = row.dataItem.id;
            },
            async onDelete(row) {
                const deleteConfirmed = await this.openConfirmBox({});
                if (deleteConfirmed) {
                    await this.deleteRecord(row.id);
                    //Get the data
                    this.getAll({});
                }
            },
            async onGetData(params) {
                await this.getAll(params);
            },
            updateList(value) {
                if (value == true) {
                    this.getAll({});
                }
            },
        },
        watch: {
            gridList() {
                //This function sets the first row as the selected row
                this.selectedRowItemId = this.setSelectedRowId(this.gridList, this.selectedRowItemId, this.lastOpenedId);
            },
        },
        async mounted() {
            await this.getChartOfAccounts(7).then((result) => {
                this.chartOfAccounts = result;
            });

          if('accountName' in this.$route.params) {
            let chartOfAccount = this.chartOfAccounts.find(x => x.accountName == this.$route.params.accountName)
            if(chartOfAccount != undefined) {
              this.filters.accountId = chartOfAccount.id;
              this.search(this.filters);
            }
            delete this.$route.params.accountName
          }else {
            this.setItem({
              resource: 'pageInfo',
              payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
            });
            await this.getAll({});
            if (this.$route.params.isAdd) {
              this.$bvModal.show('expense-modal');
              delete this.$route.params.isAdd
            }
          }
        },
    };
</script>